import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

const Header = ({ slimHeader, siteTitle }) => (
  <header
    className={`container mx-auto md:flex items-center justify-between py-4 md:py-6`}
  >
    <div className={`w-24 md:w-32 mb-4 md:mb-0 mx-auto md:mx-0`}>
      <Link to={"/"}>
        <svg
          width="107"
          height="34"
          viewBox="0 0 107 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M37.6816 10.4336L37.7695 11.6543C38.5247 10.7103 39.5371 10.2383 40.8066 10.2383C41.9264 10.2383 42.7598 10.5671 43.3066 11.2246C43.8535 11.8822 44.1335 12.8652 44.1465 14.1738V21H41.3242V14.2422C41.3242 13.6432 41.194 13.2103 40.9336 12.9434C40.6732 12.6699 40.2402 12.5332 39.6348 12.5332C38.8405 12.5332 38.2448 12.8717 37.8477 13.5488V21H35.0254V10.4336H37.6816ZM52.623 19.9258C51.9264 20.7721 50.9629 21.1953 49.7324 21.1953C48.5996 21.1953 47.7337 20.8698 47.1348 20.2188C46.5423 19.5677 46.2396 18.6139 46.2266 17.3574V10.4336H49.0488V17.2598C49.0488 18.36 49.5501 18.9102 50.5527 18.9102C51.5098 18.9102 52.1673 18.5781 52.5254 17.9141V10.4336H55.3574V21H52.7012L52.623 19.9258ZM60.084 10.4336L60.1719 11.6543C60.9271 10.7103 61.9395 10.2383 63.209 10.2383C64.3288 10.2383 65.1621 10.5671 65.709 11.2246C66.2559 11.8822 66.5358 12.8652 66.5488 14.1738V21H63.7266V14.2422C63.7266 13.6432 63.5964 13.2103 63.3359 12.9434C63.0755 12.6699 62.6426 12.5332 62.0371 12.5332C61.2428 12.5332 60.6471 12.8717 60.25 13.5488V21H57.4277V10.4336H60.084ZM75.0254 19.9258C74.3288 20.7721 73.3652 21.1953 72.1348 21.1953C71.002 21.1953 70.1361 20.8698 69.5371 20.2188C68.9447 19.5677 68.6419 18.6139 68.6289 17.3574V10.4336H71.4512V17.2598C71.4512 18.36 71.9525 18.9102 72.9551 18.9102C73.9121 18.9102 74.5697 18.5781 74.9277 17.9141V10.4336H77.7598V21H75.1035L75.0254 19.9258ZM82.5352 10.4336L82.623 11.6152C83.3717 10.6973 84.3841 10.2383 85.6602 10.2383C87.0208 10.2383 87.9551 10.7754 88.4629 11.8496C89.2051 10.7754 90.263 10.2383 91.6367 10.2383C92.7826 10.2383 93.6354 10.5736 94.1953 11.2441C94.7552 11.9082 95.0352 12.9108 95.0352 14.252V21H92.2031V14.2617C92.2031 13.6628 92.0859 13.2266 91.8516 12.9531C91.6172 12.6732 91.2038 12.5332 90.6113 12.5332C89.765 12.5332 89.179 12.9368 88.8535 13.7441L88.8633 21H86.041V14.2715C86.041 13.6595 85.9206 13.2168 85.6797 12.9434C85.4388 12.6699 85.0286 12.5332 84.4492 12.5332C83.6484 12.5332 83.069 12.8652 82.7109 13.5293V21H79.8887V10.4336H82.5352ZM103.336 21C103.206 20.7461 103.111 20.4303 103.053 20.0527C102.369 20.8145 101.48 21.1953 100.387 21.1953C99.3516 21.1953 98.4922 20.8958 97.8086 20.2969C97.1315 19.6979 96.793 18.9427 96.793 18.0312C96.793 16.9115 97.2064 16.0521 98.0332 15.4531C98.8665 14.8542 100.068 14.5514 101.637 14.5449H102.936V13.9395C102.936 13.4512 102.809 13.0605 102.555 12.7676C102.307 12.4746 101.913 12.3281 101.373 12.3281C100.898 12.3281 100.523 12.4421 100.25 12.6699C99.9831 12.8978 99.8496 13.2103 99.8496 13.6074H97.0273C97.0273 12.9954 97.2161 12.429 97.5938 11.9082C97.9714 11.3874 98.5052 10.9805 99.1953 10.6875C99.8854 10.388 100.66 10.2383 101.52 10.2383C102.822 10.2383 103.854 10.5671 104.615 11.2246C105.383 11.8757 105.768 12.7936 105.768 13.9785V18.5586C105.774 19.5612 105.914 20.3197 106.188 20.834V21H103.336ZM101.002 19.0371C101.419 19.0371 101.803 18.946 102.154 18.7637C102.506 18.5749 102.766 18.3242 102.936 18.0117V16.1953H101.881C100.468 16.1953 99.7161 16.6836 99.625 17.6602L99.6152 17.8262C99.6152 18.1777 99.7389 18.4674 99.9863 18.6953C100.234 18.9232 100.572 19.0371 101.002 19.0371Z"
            fill="#3E2B7D"
          />
          <path d="M27.5 7.5L0 0V1.57996L21.5 9.5L27.5 7.5Z" fill="#3E2B7D" />
          <path d="M0 18.019L28 9V24.981L0 34V18.019Z" fill="#3E2B7D" />
        </svg>
      </Link>
    </div>
    <div
      className={`flex flex-wrap md:flex-row items-center justify-center md:justify-normal`}
    >
      {/*{! slimHeader && <Link activeClassName={`border-b-4 border-orange-500 font-bold`} className={`py-1 font-medium mr-6 text-purple-800 w-16 text-center`} to="/digital-transformation">digital transformation</Link> }*/}
      {/*{! slimHeader && <Link activeClassName={`border-b-4 border-orange-500 font-bold`} className={`py-1 font-medium mr-6 text-purple-800 w-16 text-center`} to="/web-development-for-non-profits">nonprofits</Link> }*/}
      {/*{! slimHeader && <Link activeClassName={`border-b-4 border-orange-500 font-bold`} className={`py-1 font-medium mr-6 text-purple-800 w-16 text-center`} to="/custom-web-development-process">process</Link> }*/}
      {/*{! slimHeader && <Link activeClassName={`border-b-4 border-orange-500 font-bold`} className={`py-1 font-medium mr-6 text-purple-800 w-16 text-center`} to="/custom-web-development-stack">tech stack</Link> }*/}
      <Link
        activeClassName={`border-b-4 border-orange-500 font-bold`}
        className={`py-1 border-b-4 border-white font-medium mr-6 text-purple-800 w-16 text-center`}
        to="/"
      >
        home
      </Link>
      <Link
        activeClassName={`border-b-4 border-orange-500 font-bold`}
        className={`py-1 border-b-4 border-white font-medium mr-6 text-purple-800 w-16 text-center`}
        to="/services"
      >
        services
      </Link>
      {/*<Link activeClassName={`border-b-4 border-orange-500 font-bold`} className={`py-1 border-b-4 border-white font-medium mr-6 text-purple-800 w-16 text-center`} to="/process">process</Link>*/}
      {/*<Link activeClassName={`border-b-4 border-orange-500 font-bold`} className={`py-1 border-b-4 border-white font-medium mr-6 text-purple-800 w-16 text-center`} to="/estimator">estimator</Link>*/}
      {/* <Link activeClassName={`border-b-4 border-orange-500 font-bold`} className={`py-1 border-b-4 border-white font-medium mr-6 text-purple-800 w-16 text-center`} to="/case-studies">case studies</Link> */}
      <Link
        activeClassName={`border-b-4 border-orange-500 font-bold`}
        className={`py-1 border-b-4 border-white font-medium mr-6 text-purple-800 w-16 text-center`}
        to="/blog"
      >
        blog
      </Link>
      <Link
        activeClassName={`border-b-4 border-orange-500 font-bold`}
        className={`py-1 border-b-4 border-white font-medium mr-6 text-purple-800 w-16 text-center`}
        to="/web-development-quote"
      >
        contact
      </Link>
      <a
        className={`py-1 font-medium text-purple-800 mr-4`}
        href={`tel:3023199880`}
      >
        (302) 319-9880
      </a>

      <a
        href={`https://www.facebook.com/NunumaHQ`}
        target={`_blank`}
        className={`py-1 font-medium text-gray-400 mr-2`}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 2H20C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V4C2 2.89543 2.89543 2 4 2ZM4 4V20H20V4H4ZM11.1331 12.0044H13V18H15V12.0044H16.9824V10.0044H15V9C15 8.44772 15.4477 8 16 8H17V6H16C14.3431 6 13 7.34315 13 9V10.0044H11.1331V12.0044Z"
          />
        </svg>
      </a>
      <a
        href={`https://www.twitter.com/NunumaHQ`}
        target={`_blank`}
        className={`py-1 font-medium text-gray-400 mr-2`}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.1195 4.50827L22.5343 4.67349L21.8983 5.948C21.5882 6.56953 21.2778 7.19105 20.967 7.81258C20.9302 7.94422 20.8654 8.05962 20.7697 8.20987C20.7296 8.27265 20.5929 8.47236 20.5865 8.48194C20.5504 8.53608 20.5237 8.57878 20.5045 8.61299V11.0015C20.5045 17.1135 14.5895 20.9974 9.00354 20.9974C7.86051 20.9974 6.99207 20.9427 5.99765 20.7257C4.36115 20.3685 3.14327 19.6587 2.58597 18.418L2.01221 17.1407L3.40659 17.0124C4.66801 16.8964 5.76169 16.6561 6.60159 16.3343C4.29577 15.9635 3.0036 14.9508 3.0036 13.0489V12.0489H4.0036C4.22331 12.0489 4.42143 12.0311 4.59854 11.9983C2.868 10.9636 2.00122 9.30379 2.00122 7.00152C2.00103 6.9034 2.00103 6.90339 2.00044 6.79847C1.99394 5.63803 2.05627 5.01797 2.37395 4.22659C2.57754 3.71941 2.87183 3.24988 3.2679 2.81967L4.02251 2L4.75617 2.83847C7.17394 5.60161 9.56395 7.27795 12.0042 7.48072C12.0146 4.93105 13.9415 3.00152 16.5043 3.00152C17.6991 3.00152 18.7828 3.45501 19.6345 4.27273C20.1006 4.36851 20.5957 4.44709 21.1195 4.50827ZM18.9086 6.16202L18.6021 6.0926L18.3904 5.86028C17.8785 5.29855 17.2359 5.00152 16.5043 5.00152C15.0414 5.00152 14.0041 6.04391 14.0041 7.50152C14.0041 7.73974 13.998 7.88942 13.9683 8.08615C13.8499 8.87116 13.4096 9.50152 12.5041 9.50152C9.50607 9.50152 6.80136 7.89542 4.16389 5.15228C4.02792 5.56561 3.99595 5.99047 4.00041 6.78727C4.00101 6.89384 4.00101 6.89384 4.00122 7.00152C4.00122 9.04953 4.83093 10.1698 6.79547 10.7942L7.49255 11.0158V11.7472C7.49255 12.6342 6.65222 13.4691 5.42268 13.8431C5.98631 14.2708 7.139 14.5015 9.00389 14.5015H10.0039V15.5015C10.0039 16.9343 8.35762 18.0561 5.87075 18.6419C6.68178 18.8903 7.76166 18.9974 9.00354 18.9974C13.618 18.9974 18.5045 15.7888 18.5045 11.0015V8.50152C18.5045 8.20774 18.5897 7.95273 18.7311 7.68759C18.7865 7.58393 18.8474 7.48509 18.9225 7.37237C18.9367 7.35115 18.9892 7.27426 19.0309 7.21279L19.1101 7.05429C19.2386 6.79745 19.3669 6.54061 19.4952 6.28377C19.2958 6.24599 19.1003 6.20541 18.9086 6.16202Z"
          />
        </svg>
      </a>
      <a
        href={`https://www.linkedin.com/company/nunuma`}
        target={`_blank`}
        className={`py-1 font-medium text-gray-400`}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 2H20C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V4C2 2.89543 2.89543 2 4 2ZM4 4V20H20V4H4ZM13 9C12.4823 9 11.9353 9.15826 11.4521 9.45215L11 9H10V16H12V12C12 11.4243 12.594 11 13 11H14C14.406 11 15 11.4243 15 12V16H17V12C17 10.1472 15.394 9 14 9H13ZM8 8C8.55228 8 9 7.55228 9 7C9 6.44772 8.55228 6 8 6C7.44772 6 7 6.44772 7 7C7 7.55228 7.44772 8 8 8ZM7 9V16H9V9H7Z"
          />
        </svg>
      </a>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
